import type { Optional } from './object';
import { validateNotEmptyString } from './string';

export function parseJson<Item>(json: Optional<string>): Item {
  validateNotEmptyString(json);
  
  try {
    return JSON.parse(json);
  } catch (error) {
    console.error(`JSON is not parsable: '${json}'`);
    throw error;
  }
}

export function isJsonParsable(json: string): boolean {
  try {
    JSON.parse(json);

    return true;
  } catch (error) {
    return false;
  }
}

export function parseJsonSafely<Item>(json: string): Item | undefined {
  try {
    return JSON.parse(json) as Item;
  } catch (error) {
    console.warn('Failed to deserialize JSON. returning empty object', { json });

    return undefined;
  }
}